import { type CSSProperties, memo, useMemo } from 'react';

import { type Clip } from '@air/types';

import { type Dimension, getSpriteStyles } from '~/utils/videoThumbnails';

type VideoStaticThumbnailProps = {
  clip: Clip;
  containerDimensions: Dimension;
};

export const VideoStaticThumbnail = memo(({ clip, containerDimensions }: VideoStaticThumbnailProps) => {
  const thumbnailStyles = useMemo(() => {
    const thumbnail = clip.position?.start.thumbnail ?? 0;

    if (!clip.assets.spriteSheet) {
      return;
    }

    const spriteStyles = getSpriteStyles({
      containerWidth: containerDimensions.width,
      containerHeight: containerDimensions.height,
      spritesheet: clip.assets.spriteSheet,
      frame: thumbnail,
    });

    return {
      ...spriteStyles,
      backgroundImage: `url("${clip.assets.spriteSheet.src}")`,
    } satisfies CSSProperties;
  }, [clip, containerDimensions.width, containerDimensions.height]);

  return (
    <div className="pointer-events-none absolute inset-0 size-full overflow-hidden rounded-4">
      <div style={thumbnailStyles} />
    </div>
  );
});

VideoStaticThumbnail.displayName = 'VideoStaticThumbnail';
